import styled from 'styled-components'

export const Paragraph = styled.p`
  font-size: 1rem;
  margin: 0;
  padding: 0;
`
